import React, { useState, useEffect, useRef } from "react";
import {
  Modal,
  InputGroup,
  Form,
  FormControl,
  Button,
  Row,
  Col,
} from "react-bootstrap";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import "../../assets/css/component.css";
import "./signup.css";
import "../../assets/css/modal.css";
import close from "../../assets/svgs/close.svg";
import warley from "../../assets/svgs/warley.svg";
import { Link } from 'react-router-dom';
import { useForm } from "react-hook-form";
import Step1 from '../Modals/Step1';
import Step2 from '../Modals/Step2';
import Step3 from '../Modals/Step3';
import { withTranslation } from "react-i18next";
import { Spinner } from "react-bootstrap";
import axios from "axios";
import CloseButton from 'react-bootstrap/CloseButton';
import ReCAPTCHA from "react-google-recaptcha";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const removeCharAt = (string, index) => {
  const arr = string.split("")
  arr.splice(index, 1)
  return arr.join("")
}

const insert = (string, index, newString) => {
  if (index >= 0) {
    return string.substring(0, index) + newString + string.substring(index)
  }
}

const validDay = (string) => {
  if (string.length === 2) {
    const day = string.substring(0, 2)
    if (isNaN(day)) {
      return false
    } else {
      return true
    }
  } else {
    return false
  }
}

const validMonth = (string) => {
  if (string.length === 5) {
    const month = string.substring(3, 5)
    if (isNaN(month)) {
      return false
    } else if (string.substring(2, 3) === "/") {
      return true
    }
  } else {
    return false
  }
}



const Signup = (props) => {
  const { register, reset, handleSubmit, watch, setValue } = useForm();
  const [checked, setChecked] = useState(1);
  const [signInVal, setSignInVal] = useState(null);
  const [show, setShow] = useState(null);
  const [clLogin, setClogin] = useState(false);

  const defaultError = {
    firstName: "",
    lastName: "",
    phoneNumber: "",
    birthDay: "",
    otp: "",
  };

  const [errors, setErrors] = useState(defaultError);

  const [phoneCode, setPhoneCode] = useState("+65");
  const [isOtpVerified, setOtpVerified] = useState(false);
  const [isVerifying, setVerifying] = useState(false);
  //Element references
  const mobileNumberElement = useRef(null);
  const countryCodeElement = useRef(null);
  const [DOB, setDOB] = useState("");
  const stringPlacement = useRef(0);
  const keyCode = useRef("");
  // const DOBElement = useRef(null);
  const recaptchaRef = useRef();
  const [captchaToken, setCaptchaToken] = useState(null);
  const onSubmit = (data) => {
    setErrors({ ...defaultError });
    const newError = {
      birthDay: "",
      phoneNumber: "",
    };
    {/*if (
      !/^[0-9]{2}[\/]{1}[0-9]{2}[\/]{1}[0-9]{4}$/g.test(
        data?.dob
      )
    ) {
      newError["birthDay"] = "Invalid birth day";
    }
*/}
    // Validate date format
    if (!/^[0-9]{2}\/[0-9]{2}\/[0-9]{4}$/g.test(data?.dob)) {
      newError["birthDay"] = "Invalid date format";
    } else {
      const [day, month, year] = data.dob.split("/").map(Number);
      const currentYear = new Date().getFullYear();
      const minYear = 1900;
      const maxYear = currentYear - 18; // must be at least 18

      // Check day validity
      if (day < 1 || day > 31) {
        newError["birthDay"] = "Invalid date";
      }
      // Check month validity
      else if (month < 1 || month > 12) {
        newError["birthDay"] = "Invalid month";
      }
      // Check year validity
      else if (year < minYear || year > currentYear) {
        newError["birthDay"] = "Invalid year";
      }
      // Check if under 18
      else {
        const today = new Date();
        const dobDate = new Date(year, month - 1, day);
        const age = today.getFullYear() - dobDate.getFullYear();
        const m = today.getMonth() - dobDate.getMonth();

        if (age < 18 || (age === 18 && m < 0)) {
          newError["birthDay"] = "You must be at least 18 years old";
        }
      }
    }

    if (phoneCode != "+91" && !/^(6|8|9)\d{7}$/.test(mobileNumberElement.current.value)) {
      newError["phoneNumber"] = "Invalid phone number";
    }

    if (!newError.birthDay && !newError.phoneNumber) {
      const dob = data?.dob;
      let dobFormat = "";
      if (dob) {
        const parts = dob.split("/"); // ["02", "05", "2000"]
        if (parts.length === 3) {
          dobFormat = `${parts[2]}-${parts[1]}-${parts[0]}`; // 2000-05-02
        }
      }
      let newData = {
        ...props.signupVal,
        last_name: data.last_name,
        first_name: data.first_name,
        gender: checked === 1 ? "Male" : "Female",
        mobile: props?.user?.contact_number
          ? props?.user?.contact_number
          : phoneCode + mobileNumberElement.current.value,
        contact_number: props?.user?.contact_number
          ? props?.user?.contact_number
          : phoneCode + mobileNumberElement.current.value,
        dob: dobFormat,
        otp: data.otp,
        platform: 'fooddelivery'
      };
      props.setSignup(newData);
      props.nextStep();
      // reset();
    }
    setErrors({ ...errors, ...newError });
  };
  const showModal = (event, val) => {
    event && event.preventDefault();
    setShow(val);
  };

  const ChnageChecked = (value) => {
    setChecked(value);
  };
  const setLoginValue = (data) => {
    setSignInVal(data);
  };
  const loginClicked = (data) => {
    if (data.password && data.phone && !clLogin) {
      props.loginUser(data, true);
      setClogin(true);
    }
  };
  const CloseloggedIn = () => {
    setShow(null);
  };

  function handleClick(event) {
    event.preventDefault();
    props.closeModal();

    showModal(event, 1);
  }

  const countries = [
    {
      name: "SG",
      phoneCode: "+65",
    },
    {
      name: "IN",
      phoneCode: "+91",
    },
  ];

  useEffect(() => {
    if (props?.user?.country_code_value) {
      setPhoneCode(props.user.country_code_value);
    }
  }, [props?.user?.country_code_value]);


  axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;
  const [isSending, setSending] = useState(false);
  const [otpTimer, setOtpTimer] = useState(60);
  const [otpSent, setOtpSent] = useState(false);
  const timerRef = useRef(null);
  const [alert, setAlert] = useState({ message: "", type: "" });
  const [otpResend, setOtpResend] = useState(false);

  const sendMobileOTP = async () => {
    if (!captchaToken) {
      setErrors(prev => ({ ...prev, otp: "Please verify the CAPTCHA first" }));
      return;
    }
    try {
      const payload = {
        contact_number:
          props?.user?.country_code_value + props?.user?.partial_number,
        business_id: localStorage.getItem("business_id"),
        country_code: props?.user?.country_code_value,
        captcha_token: captchaToken,
      };

      setSending(true);

      const response = await axios.post("auth/send-otp", payload, {
        headers: { "Content-Type": "application/json" },
      });
      const data = response.data;
      setSending(false);

      if (data.success) {
        // clear any otp-related error and show success toast if desired
        setErrors(prev => ({ ...prev, otp: "" }));
        toast.success("OTP has been sent, you will receive shortly");

        setOtpSent(true);
        // start countdown
        setOtpTimer(60);
        setErrors(prev => ({ ...prev, otp: "" }));
        if (timerRef.current) clearInterval(timerRef.current);
        timerRef.current = setInterval(() => {
          setOtpTimer(prev => {
            if (prev <= 1) {
              clearInterval(timerRef.current);
              timerRef.current = null;
              setOtpSent(false); // enable Send OTP again
              return 0;
            }
            return prev - 1;
          });
        }, 1000);
      } else {
        setAlert({
          message: data?.message || "Something went wrong, please try again.",
          type: "error",
        });
      }
    } catch (error) {
      setAlert({
        message:
          error.response?.data?.message ||
          "Failed to send OTP. Please try again later.",
        type: "error",
      });
      setTimeout(() => {
        setAlert(null);
      }, 3000);
    } finally {
      setSending(false);
      recaptchaRef.current.reset();
      setCaptchaToken(null);
    }
  };

  useEffect(() => {
    if (!otpSent && !isOtpVerified && otpTimer == 0) {
      setOtpResend(true);
    }
  }, [!isOtpVerified, !otpSent]);

  const verifyOTP = async () => {
    // if (!captchaToken) {
    //   // setAlert({
    //   //   message: "Please verify the CAPTCHA first",
    //   //   type: "error"
    //   // });
    //   toast.error("Please verify the CAPTCHA first");
    //   setTimeout(() => setAlert(null), 3000);
    //   return;
    // }
    try {
      const payload = {
        contact_number:
          props?.user?.country_code_value + props?.user?.partial_number,
        otp: watch("otp"),
        business_id: localStorage.getItem("business_id"),
        country_code: props?.user?.country_code_value,
      };

      setVerifying(true);

      const response = await axios.post("auth/verify_otp_twilio", payload, {
        headers: { "Content-Type": "application/json" },
      });

      const data = response.data;
      setVerifying(false);

      if (data.success && data.valid) {
        setOtpVerified(true);
        toast.success("OTP verified successfully!");
        // setTimeout(() => setAlert(null), 3000);
      } else {
        setOtpVerified(false);
        setOtpSent(false);
        setValue("otp", "");
        toast.error("Verification failed. Please try again" || "Invalid OTP");
        // setTimeout(() => setAlert(null), 3000);
      }
    } catch (error) {
      setVerifying(false);
      setOtpVerified(false);
      setOtpSent(false);
      setValue("otp", "");
      toast.error("Verification failed. Please try again.");
      // setTimeout(() => setAlert(null), 3000);
    } finally {
      // recaptchaRef.current.reset();
      // setCaptchaToken(null);
    }
  };
  // useEffect(()=>{
  //   if (keyCode.current === "Backspace") {
  //     setDOB(removeCharAt(DOB, stringPlacement.current))
  //   } else {

  //   }

  // }, [DOB])

  const resendOTP = () => {
    sendMobileOTP();
  };

  return (
    <Modal
      show={props.show}
      onHide={props.joinus ? () => { } : props.closeModal}
      dialogClassName="modal-md xs"
      contentClassName="xs"
      centered
    >
      <Step1
        show={show === 1 ? true : false}
        closeModal={() => setShow(null)}
        showNext={(event) => showModal(event, 2)}
      />

      <Step2
        show={show === 2 ? true : false}
        closeModal={() => setShow(null)}
        signInVal={signInVal}
        setLoginValue={setLoginValue}
        showNext={(event) => showModal(event, 3)}
      />

      <Step3
        signInVal={signInVal}
        loginClicked={loginClicked}
        setLoginValue={setLoginValue}
        show={show === 3 ? true : false}
        closeModal={CloseloggedIn}
      />
      <form onSubmit={handleSubmit(onSubmit)} className="modal_form">
        <Modal.Body className="px-5 py-4">
          {props.joinus ? (
            ""
          ) : (
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={props.closeModal}
              data-testid="signup_close"
            >
              <img src={close} width="20" alt="close" />
            </button>
          )}
          <div className="text-center mt-5">
            <img src={warley} width="263px" height="55px" alt="warley" />
            <div className="signup-subtitle">Sign up for WARELY account</div>
            {alert?.message && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "10px",
                  background: alert?.type === "error" ? "#dc3545" : "#1E9D42",
                  color: "#fff",
                  padding: "12px 10px",
                  borderRadius: "4px",
                  marginBottom: "20px",
                }}
              >
                <span>{alert?.message}</span>

                {/* Close button */}
                <button
                  onClick={() => setAlert({ message: "", type: "" })}
                  class="btn-close"
                  style={{
                    background: "transparent",
                    border: "none",
                    color: "#fff",
                    fontSize: "16px",
                    fontWeight: "bold",
                    cursor: "pointer",
                    marginLeft: "10px",
                  }}
                >
                  <CloseButton className="close-icon" variant="white" />
                </button>
              </div>
            )}

            <div className="">
              <div className="input-title mb-2">First name</div>
              <div className="mb-2">
                <input
                  minLength={3}
                  required
                  type="text"
                  autoComplete="off"
                  {...register("first_name")}
                  className="form-control-lg input input-full"
                />
              </div>
            </div>
            <div className="mt-4">
              <div className="input-title mb-2">Last name</div>
              <div className="mb-2">
                <input
                  minLength={3}
                  required
                  type="text"
                  autoComplete="off"
                  {...register("last_name")}
                  className="form-control-lg input input-full"
                />
              </div>
            </div>

            <div className="mt-4">
              <div className="input-title mb-2">Gender</div>

              <div className="app-radio-inline">
                <Row className="gender">
                  <Col className="6">
                    <Button
                      size="lg"
                      onClick={() => ChnageChecked(1)}
                      variant={checked === 1 ? "danger" : "outline-danger"}
                    >
                      {" "}
                      Male
                    </Button>
                  </Col>
                  <Col className="6">
                    <Button
                      onClick={() => ChnageChecked(2)}
                      size="lg"
                      variant={checked === 2 ? "danger" : "outline-danger"}
                    >
                      {" "}
                      Female
                    </Button>
                  </Col>
                </Row>
              </div>
            </div>

            <div className="mt-3 pt-2 mb-3 mb-md-0">
              <div className="input-title mb-2">Birthday</div>
              <div className="mb-2">
                <input
                  maxLength={10}
                  minLength={3}
                  required
                  placeholder="DD / MM / YYYY"
                  type="text"
                  autoComplete="off"
                  // ref={DOBElement}
                  {...register("dob", {
                    onChange: (event) => {
                      event.target.value = event.target.value.replace(
                        /[^0-9\/]/,
                        ""
                      );
                      if (!(keyCode.current === "Backspace")) {
                        if (validDay(event.target.value)) {
                          event.target.value = event.target.value + "/";
                        }
                        if (validMonth(event.target.value)) {
                          event.target.value = event.target.value + "/";
                        }
                      }
                    },
                  })}
                  onKeyDown={(event) => {
                    if (event.key === "Backspace") {
                      keyCode.current = "Backspace";
                    } else {
                      keyCode.current = "";
                    }
                  }}
                  className="form-control-lg input input-full"
                  id="dob"
                />
              </div>
              <div className="text-danger footer-warley-description">
                {errors.birthDay}
              </div>
            </div>

            <div className="mt-3 pt-2 mb-3 mb-md-0">
              <Row>
                <Col md={6}>
                  <div className="input-title mb-2">Phone number</div>
                  <InputGroup className="mb-2 mr-sm-2 phone-group">
                    <InputGroup.Prepend>
                      {/* <InputGroup.Text>@</InputGroup.Text> */}
                      <Form.Group controlId="exampleForm.ControlSelect1 px-1">
                        <Form.Control
                          ref={countryCodeElement}
                          value={props?.user?.country_code_value}
                          onChange={(e) => {
                            const newPhoneCode = e.target.value;
                            setPhoneCode(newPhoneCode);
                          }}
                          disabled={props?.user?.country_code_value}
                          as="select"
                        >
                          {countries.map(({ name, phoneCode }, index) => (
                            <option key={index} value={phoneCode} name={name}>
                              {name}
                            </option>
                          ))}
                        </Form.Control>
                      </Form.Group>
                    </InputGroup.Prepend>
                    <div className="mobile_number">
                      {props?.user?.country_code_value
                        ? props?.user?.country_code_value
                        : phoneCode}
                    </div>
                    {props?.user?.partial_number ? (
                      <FormControl
                        type="text"
                        minLength={8}
                        maxLength={8}
                        id="mobileInputElement"
                        placeholder={props?.user?.partial_number}
                        ref={mobileNumberElement}
                        value={props?.user?.partial_number}
                        disabled={props?.user?.country_code_value}
                        style={{
                          padding: "0.300rem 0.40rem",
                          border: 0,
                          borderColor: "#E9ECEF",
                        }}
                      />
                    ) : (
                      <FormControl
                        onChange={(event) => {
                          console.log(mobileNumberElement.current.value);
                        }}
                        type="text"
                        minLength={8}
                        maxLength={8}
                        id="mobileInputElement"
                        ref={mobileNumberElement}
                        style={{
                          padding: "0.300rem 0.40rem",
                          border: 0,
                          borderColor: "#E9ECEF",
                          backgroundColor: "#E9ECEF",
                        }}
                      />
                    )}
                    <div className="text-danger footer-warley-descriptionq">
                      {errors.phoneNumber}
                    </div>
                  </InputGroup>
                </Col>
                <Col md={6}>
                  <div className="input-title mb-2">Enter OTP </div>
                  <InputGroup>
                    <FormControl
                      minLength={3}
                      required
                      type="text"
                      autoComplete="off"
                      {...register("otp")}
                      placeholder="Enter OTP"
                      className="form-control-lg input input-full"
                      style={{
                        padding: "30px 10px",
                        border: 0,
                        borderColor: "#E9ECEF",
                        borderRadius: 0,
                      }}
                      disabled={!otpSent}
                    />
                    {
                      !otpSent ?
                        <Button
                          variant="outline-danger otp-button"
                          onClick={!otpResend ? sendMobileOTP : resendOTP}
                        >
                          {"Send OTP"}
                        </Button>
                        :
                        <Button
                          variant="success"
                          onClick={verifyOTP}
                          disabled={!otpSent || isVerifying || isOtpVerified}
                          className="verify-otp-btn"
                        >
                          {isVerifying ? "Verifying..." : isOtpVerified ? "Verified" : "Verify OTP"}
                        </Button>
                    }

                  </InputGroup>

                  {/* inline OTP / captcha error message */}
                  <div className="text-danger footer-warley-description" style={{ marginTop: 6 }}>
                    {errors.otp}
                  </div>

                  {otpSent && !isOtpVerified && otpTimer > 0 ? (
                    <div className="otp-text">
                      <span>Haven't received the code yet?</span>
                      <span style={{ color: "#FC3F3F", marginLeft: "5px" }}>
                        Resend OTP in {otpTimer} seconds
                      </span>
                    </div>
                  ) : null}
                </Col>
              </Row>
            </div>

            <div className="recaptcha-wrapper mt-3">
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                onChange={(token) => {
                  setCaptchaToken(token);
                  setErrors(prev => ({ ...prev, otp: "" })); // clear inline error when captcha solved
                }}
                onExpired={() => {
                  setCaptchaToken(null);
                }}
              />
            </div>
            {/* <div className="d-flex justify-content-center mt-4">
              <div className="footer-warley-description">
                Once succesfully created, you can use WARELY account across all
                partners with WARELY
              </div>
            </div> */}
          </div>
        </Modal.Body>
        <Modal.Footer className="modal-footer">
          <button
            type="submit"
            className="btn btn-danger btn-success rounded font-weight-bold w-100 py-3 f18"
            data-dismiss="modal"
            disabled={!isOtpVerified}
          >
            Continue
          </button>
          {/* <p>Already a member? <Link 
            aria-label="Close" 
            onClick={handleClick}
            >Log in</Link></p> */}
          <div className="powered my-4 w-100">Powered by Warely</div>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  user: state.auth.user
});

export default withTranslation()(
  connect(mapStateToProps)(Signup)
);


